export type Currency = 'USD' | 'EUR' | 'GBP';

export interface CurrencyConfig {
    code: Currency;
    symbol: string;
    rate: number;
}

export const CURRENCY_MAP: Record<Currency, CurrencyConfig> = {
    GBP: { code: 'GBP', symbol: '£', rate: 1.0 },
    USD: { code: 'USD', symbol: '$', rate: 1.28 },
    EUR: { code: 'EUR', symbol: '€', rate: 1.18 }
};

export function detectCurrency(): CurrencyConfig {
    if (typeof window === 'undefined') return CURRENCY_MAP.GBP;

    try {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const locale = navigator.language;

        // Simple region detection
        if (timeZone.includes('London') || locale === 'en-GB') {
            return CURRENCY_MAP.GBP;
        }

        if (timeZone.includes('Europe') || ['de', 'fr', 'it', 'es', 'nl', 'be', 'at'].some(l => locale.startsWith(l))) {
            return CURRENCY_MAP.EUR;
        }

        if (timeZone.includes('America') || locale === 'en-US') {
            return CURRENCY_MAP.USD;
        }
    } catch (e) {
        console.warn('Currency detection failed, falling back to GBP', e);
    }

    return CURRENCY_MAP.GBP;
}

export function convertPrice(usdPrice: number, rate: number): number {
    return Math.round(usdPrice * rate);
}
